import React, { useState, useEffect } from 'react';
import Nabvar from '../components/Navbar/Navbar'
import { Outlet } from 'react-router-dom';
import { useMediaQuery } from '@react-hook/media-query';
import Footer from '../components/Footer/Footer'
import BtnWhatsapp from '../components/BtnWhatsapp/BtnWhatsapp'
import Cart from '../components/Cart/Cart'
export default function IndexLayout({ logo }) {



    const isScreenLarge = useMediaQuery('(min-width: 900px)');
    return (
        <div >
            {isScreenLarge ?
                <>
                    <Nabvar logo={logo} />
                    <Outlet />
                    <Footer logo={logo} />
                    <BtnWhatsapp />
                    <Cart />
                </> :
                <>

                    <Outlet />
                    <Footer logo={logo} />
                    <Cart />
                </>}

            <div className='espaciobg2'>

            </div>

        </div>
    );
}
